
import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Inicio', href: '#inicio' },
    { name: 'Calculadora', href: '#calculadora' },
    { name: 'Servicios', href: '#servicios' },
    { name: 'Nosotros', href: '#sobre-nosotros' },
    { name: 'Opiniones', href: '#testimonios' },
    { name: 'FAQ', href: '#faq' }
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 sm:h-20">
          {/* Logo */}
          <a href="#inicio" className="flex items-center gap-2 sm:gap-3 group">
            <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-teal-600 rounded-lg sm:rounded-xl group-hover:bg-teal-700 transition-colors">
              <i className="ri-car-line text-xl sm:text-2xl text-white"></i>
            </div>
            <div>
              <div className={`font-bold text-sm sm:text-lg leading-tight ${isScrolled ? 'text-gray-900' : 'text-white'}`}>
                Desguace
              </div>
              <div className={`text-xs sm:text-sm font-medium ${isScrolled ? 'text-teal-600' : 'text-teal-300'}`}>
                Castelldefels
              </div>
            </div>
          </a>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center gap-6 xl:gap-8">
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                onClick={(e) => {
                  e.preventDefault();
                  const target = link.href === '#inicio' ? document.body : document.querySelector(link.href);
                  target?.scrollIntoView({ behavior: 'smooth' });
                }}
                className={`font-medium transition-colors whitespace-nowrap text-sm ${
                  isScrolled
                    ? 'text-gray-700 hover:text-teal-600'
                    : 'text-white hover:text-teal-300'
                }`}
              >
                {link.name}
              </a>
            ))}
          </div>

          {/* CTA Button */}
          <div className="hidden lg:flex items-center gap-4">
            <a
              href="tel:+34932932913"
              className={`flex items-center gap-2 px-5 xl:px-6 py-2.5 sm:py-3 rounded-full font-semibold transition-all whitespace-nowrap text-sm ${
                isScrolled
                  ? 'bg-teal-600 text-white hover:bg-teal-700'
                  : 'bg-white text-teal-600 hover:bg-gray-100'
              }`}
            >
              <i className="ri-phone-line text-lg"></i>
              Llamar Ahora
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors ${
              isScrolled ? 'text-gray-900 hover:bg-gray-100' : 'text-white hover:bg-white/10'
            }`}
          >
            <i className={`text-2xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="lg:hidden bg-white border-t border-gray-200 shadow-xl">
          <div className="px-4 py-3 space-y-1">
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                onClick={(e) => {
                  e.preventDefault();
                  const target = link.href === '#inicio' ? document.body : document.querySelector(link.href);
                  target?.scrollIntoView({ behavior: 'smooth' });
                  setIsMobileMenuOpen(false);
                }}
                className="block px-4 py-3 text-gray-700 hover:bg-teal-50 hover:text-teal-600 rounded-lg font-medium transition-colors whitespace-nowrap text-sm"
              >
                {link.name}
              </a>
            ))}
            <a
              href="tel:+34932932913"
              className="flex items-center justify-center gap-2 px-4 py-3 bg-teal-600 text-white rounded-lg font-semibold hover:bg-teal-700 transition-colors whitespace-nowrap text-sm mt-2"
            >
              <i className="ri-phone-line text-lg"></i>
              Llamar Ahora
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}
